import Monster from './Monster.js'


export default Monster